import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { HomeComponent } from './components/home/home.component';
import { environment } from '../environments/environment';
import { OktaAuth } from '@okta/okta-auth-js';
import {
  OKTA_CONFIG,
  OktaAuthGuard,
  OktaAuthModule,
  OktaCallbackComponent,
} from '@okta/okta-angular';
import { AuthGuard } from './auth.guard';
import { ClientsComponent } from './components/clients/clients.component';
import { NavigationComponent } from './components/navigation/navigation.component';
const oktaAuth = new OktaAuth({
  ...environment.authConfig,
});
const routes: Routes = [
  { path: 'implicit/callback', component: OktaCallbackComponent },
  {
    path: '',
    component: HomeComponent,
    canActivate: [OktaAuthGuard, AuthGuard],
  },
  {
    path: 'clients',
    component: ClientsComponent,
    canActivate: [OktaAuthGuard, AuthGuard],
  },
  {
    path: 'navigation',
    component: NavigationComponent,
    canActivate: [OktaAuthGuard, AuthGuard],
  },
  {
    path: 'home',
    component: HomeComponent,
    canActivate: [OktaAuthGuard, AuthGuard],
  },
];

@NgModule({
  //imports: [RouterModule.forRoot(routes)],
  imports: [
    OktaAuthModule.forRoot({ oktaAuth }),
    [RouterModule.forRoot(routes, { bindToComponentInputs: true })],
  ],

  /*providers: [
    { provide: OKTA_CONFIG, useValue: env.oidc },
  ],*/
  exports: [RouterModule],
})
export class AppRoutingModule {}
